



















import ApiClient from '@/js/api.js'
import PopupTemplate from '@/views/templates/africadogs/PopupTemplate.vue'
import QuizAfricaDogs from '@/views/organisms/QuizAfricaDogs.vue'

export default
  components: {
    PopupTemplate
    QuizAfricaDogs
  }

  data: () ->
    baseColor: '#ECC236'
    point: 0
    mode: 0
    quizResult: 0
    quizData:
      hukidashi: [
        '僕、中須がアフリカ文化の中で'
        '一番惹かれたことは次のうちどれでしょうか？'
      ]
      quiz: [
        'アフリカの力強いダンス文化'
        'トーゴのソウルフード文化'
        'オーダーメイドの仕立て文化'
      ]
      success_message: [
        'アフリカではお祝い事や特別な日に、マルシェで買った布で服を仕立ててもらう文化がある。特別な日に特別な服を着る文化がとても素敵だと思ったんだ。'
      ]
      answer: 3

  methods: {
    closePopup: () ->
      m = @mode
      if m == 0
        m = 2
      @$emit('closePopup', m)
    success: () ->
      @mode = 3
      @quizResult = 2
      @baseColor = '#F699AB'
      api = new ApiClient()
      param =
        'point_code': 'p3-2'
      data = await api.post('/member/point/save', true, param)
      @point = data.point
      if @point > 0
        @$emit('addPoint', @point)
      @$emit('success')
    miss: () ->
      @baseColor = '#7BCAD8'
      @mode = 2
      @quizResult = 1
  }
